import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import {useEffect, useState} from 'react';
import {SingleTerm} from './SingleTerm';

export const TermsList = observer(() => {
  const {
    contentOptimizer: {
      currentPage: {
        termsForInsertion,
        termsAssistantSuggestions,
      },
    }} = useStore('');

  const [finalTermsList, setFinalTermsList] = useState([]);

  useEffect(() => {
    setFinalTermsList([]);
    if (termsAssistantSuggestions?.length) {
      for (let i = 0; i < termsForInsertion.length; i++) {
        const termOccurances = termsAssistantSuggestions.filter(suggestion => suggestion.termIncluded?.includes(termsForInsertion[i].name));
        if (termOccurances?.length) {
          setFinalTermsList(cur => [...cur, {...termsForInsertion[i], placements: termOccurances?.length}]);
        }
      }
    }
  }, [...(termsAssistantSuggestions ?? []), ...(termsForInsertion ?? 0)]);

  return <div style={{display: 'flex', flexDirection: 'column'}}>
    {finalTermsList?.map((term, idx) => {
      return <SingleTerm term={term} key={idx}/>;
    })}
  </div>;
});
